angular.module("vendor")
.controller("ExportSequenceModalController", function(
    $rootScope, $scope, $attrs, FormError, close, ProductSequenceService
) {
    $scope.sequences = ProductSequenceService.query();
    $scope.modalTitle = $attrs.modalTitle;
    $scope.selectedSequenceId = null;

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        close.apply(this, arguments);
    };

    this.submit = function() {
        $scope.SequenceSelectForm.$setSubmitted();
        this.close($scope.selectedSequenceId);
    };
});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/export-sequence.modal.js
// module id = 895
// module chunks = 0